export function getPhonebookProfilePath(userUuid: string): string {
  return `/phonebook/${userUuid}`;
}
